import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Dropdown from "react-bootstrap/Dropdown";
import PreconisationsList from "../../components/Operations/PreconisationsList";
import PreconisationsModal from "../../components/Operations/PreconisationsModal";
import { store } from "../../reducer/Store";
import ApiService from "../../services/ApiService";
import { Spinner, Card, Alert } from "react-bootstrap";

/**
 * Preconisations Page Component
 *
 * Main page for managing operation PLV precos (recommendations/images).
 * Displays operations filtered by selected brands and year.
 */
export default function Preconisations() {
  const { dispatch, state } = React.useContext(store);
  const [showModal, setShowModal] = React.useState(false);
  const [selectedOperation, setSelectedOperation] = React.useState(null);
  const [operations, setOperations] = React.useState([]);
  const [loader, setLoader] = React.useState(false);

  /**
   * Fetches all operations with their PLVs for the selected brands and year
   */
  const getAllOperations = async () => {
    // Get current brands
    const brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );

    if (brands.length === 0 || !state.currentYear.value) {
      setOperations([]);
      return;
    }

    setLoader(true);

    ApiService.request(
      {},
      `operation-precos-by-brands-year/${brands}/${state.currentYear.value}`,
      "get"
    )
      .then(function (response) {
        setLoader(false);
        setOperations(response.data || []);
      })
      .catch(function (error) {
        setLoader(false);
        console.error(error);

        if (error.response?.data?.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Opens the modal for a specific operation
   * @param {Object} operation - The operation object
   */
  const handleShowModal = (operation) => {
    setSelectedOperation(operation);
    setShowModal(true);
  };

  /**
   * Closes the modal and resets selected operation
   */
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedOperation(null);
  };

  /**
   * Callback after successful save - refresh the operations list
   */
  const handleSaveSuccess = () => {
    getAllOperations();
  };

  /**
   * Effect to fetch operations when brands or year changes
   */
  React.useEffect(() => {
    if (state.currentBrands.length > 0) {
      getAllOperations();
    } else {
      setOperations([]);
    }
  }, [state.currentYear, state.currentBrands]);

  return (
    <>
      <h1>
        Préconisations
        {/* <Dropdown className="d-inline-block">
          <Dropdown.Toggle>
            <MoreVertIcon />
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item disabled>Aucune action disponible</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown> */}
      </h1>

      {showModal && (
        <PreconisationsModal
          show={showModal}
          handleClose={handleCloseModal}
          operation={selectedOperation}
          onSaveSuccess={handleSaveSuccess}
        />
      )}

      {state.currentBrands.length > 0 ? (
        <>
          {!loader ? (
            operations.length > 0 ? (
              operations.map((operation, i) => (
                <PreconisationsList
                  key={operation.id || i}
                  operation={operation}
                  handleShowModal={handleShowModal}
                />
              ))
            ) : (
              <Card className="text-center">
                <Card.Body>
                  <Alert variant="info" className="m-0">
                    La liste est vide.
                  </Alert>
                </Card.Body>
              </Card>
            )
          ) : (
            <div className="text-center pt-5">
              <Spinner
                animation={loader ? "border" : false}
                role="status"
              ></Spinner>
            </div>
          )}
        </>
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner au moins une marque.
            </Alert>
          </Card.Body>
        </Card>
      )}
    </>
  );
}
